/**
 * Converts the `svg` to a base-64 encoded [`data:` URL](https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs) string.
 * This can then be used as the `source` for an `Image` component to include custom SVGs in the checkout UI.
 */
export const encodeSvgToDataUri = (svg: string) =>
  `data:image/svg+xml,${encodeURIComponent(svg)}`;
